import OTHER from './i18n-langs.js';

// Textes du parcours « Compose ton lot », par langue (demande de Theo, 18/10/2026 : pub Meta aux Pays-Bas).
// La langue vient de TrueLang (attribut data-lang posé par le shortcode), repli sur <html lang>, puis le français.
// Gabarits avec {variables} : jamais de phrase construite par concaténation, l'ordre des mots change selon la langue.
// Les noms de produits ne sont pas ici : ils viennent traduits de WordPress (titres WooCommerce passés par TrueLang).
// Les noms de catégories, de produits et la note de précommande viennent du configurateur, en français :
// traduits par `terms` (prioritaires sur les titres WooCommerce traduits par TrueLang, qui servent de secours).

const FR = {
  locale: 'fr-FR',
  ord: ['1er', '2e', '3e'],                                   // texte brut (attributs aria)
  ordH: ['1<sup>er</sup>', '2<sup>e</sup>', '3<sup>e</sup>'], // affichage, en exposant
  ui: {
    loading: 'Chargement…',
    loadError: 'Le lot ne peut pas être chargé pour le moment. Rechargez la page.',
    noLot: 'Aucun lot disponible.',
    ariaPreview: 'Aperçu du sac',
    ariaNav: 'Navigation du lot',
    ariaSteps: 'Étapes du lot',
    composeLot: 'Composez votre lot à {badge}',
    seeRecap: 'Voir le récapitulatif',
    hoverSizeHere: 'Survolez une taille pour la voir ici',
    captionWithFlap: '{size} · avec le rabat {flap}',
    captionFlapTodo: '{size} · rabat à choisir',
    captionStart: 'Choisissez votre sac pour commencer',
    removeAria: 'Retirer {name}',
    remove: 'Retirer',
    flapN: '{ord} rabat',
    toChoose: 'À choisir',
    next: 'Suivant',
    checkout: 'Finaliser ma commande',
    addToSelectionN: 'Ajouter à ma sélection ({n})',
    update: 'Mettre à jour',
    addToSelection: 'Ajouter à ma sélection',
    recap: 'Récapitulatif',
    adding: 'Ajout en cours…',
    added: '✓ Lot ajouté !',
    addToCart: 'Ajouter au panier',
    deltaOnLot: '{delta} sur votre lot',
    yourSelection: 'Votre sélection',
    chooseSize: 'Choisissez une taille',
    fromPrice: 'dès {price}',
    bagPlus3: 'Sac + 3 rabats',
    saved: '{amount} économisés',
    shipBar: '+ Frais de port offerts en point relais',
    prevStepAria: 'Étape précédente',
    prev: 'Précédent',
    stepBag: 'Sac',
    stepAccessories: 'Accessoires',
    backTo: 'Revenir à : {step}',
    dimsTitle: 'Hauteur × largeur × profondeur',
    included: 'Inclus : {items}',
    and: ' et ',
    inclClasp: 'fermoir {name}',
    lotBag3: 'Lot sac + 3 rabats',
    whichSize: 'Quelle taille de sac ?',
    takenAria: '{name}, déjà choisi en {ord} rabat',
    soldOutAria: '{name}, épuisé',
    soldOut: 'Épuisé',
    alreadyIncluded: 'Déjà dans votre lot',
    includedAria: '{name}, déjà dans votre lot',
    whichFlap: 'Quel {ord} rabat ?',
    prevFlapsAria: 'Rabats précédents',
    nextFlapsAria: 'Rabats suivants',
    hoverSize: 'Survolez une taille pour la voir à gauche.',
    hoverFlap: "Survolez un rabat pour l'essayer sur votre sac.",
    askMore: "Voulez-vous ajouter d'autres accessoires à {pct} ?",
    askAnother: 'Voulez-vous ajouter un autre accessoire à {pct} ?',
    tickHint: "Cochez ce qui vous plaît : vos accessoires s'ajoutent à gauche. Plusieurs choix possibles.",
    accessoriesCount: { one: '{n} accessoire', other: '{n} accessoires' },
    selectionPlus: 'Votre sélection + {count}',
    whichAccessory: 'Quel accessoire ?',
    cancel: 'Annuler',
    multiple: 'Plusieurs choix possibles',
    notChosen: 'Pas encore choisi',
    edit: 'Modifier',
    accessoryOf: 'Accessoire · {cat}',
    recapTitle: 'Votre sélection à {pct}',
    totalPrice: 'Prix total : {price}',
    lotPrice: 'Prix du lot : {price}',
    youSave: 'Vous économisez : {amount}',
    shipRecap: '<b>En plus, grâce à votre lot</b>, la livraison en point relais vous est offerte.',
    addAccessory: '+ Ajouter un accessoire à {pct}',
    chooseFlapsHint: 'Choisissez vos 3 rabats pour ajouter le lot au panier.',
    doneTitle: 'Votre lot est dans votre panier',
    doneSave: 'Vous avez économisé {amount}.',
    doneSaveShip: 'Vous avez économisé {amount}, et la livraison en point relais vous est offerte.',
    another: 'Composer un autre lot',
    continueShopping: 'Continuer mes achats',
    cartError: "Erreur lors de l'ajout du lot au panier",
    cartWarning: "Votre lot est bien dans le panier, mais un accessoire n'est plus disponible et n'a pas été ajouté.",
    // Fermoirs : avec ou sans charm (wizard.js, claspBody)
    clasps: 'Fermoirs',
    charmFirst: "Choisissez d'abord votre charm",
    claspStep1: 'Choisissez votre fermoir perforé',
    claspQ: 'Avec ou sans charm ?',
    claspNo: 'Sans charm',
    claspNoHint: 'Fermoir sans trou',
    claspYes: 'Avec un charm',
    claspYesHint: 'Fermoir perforé + charm à accrocher',
    charmPick: 'Choisissez votre charm : il s\'accroche dans le trou du fermoir.',
    charmMissing: 'Votre fermoir perforé attend son charm : sans charm, le trou reste vide.',
    charmCta: 'Choisir un charm',
  },
  // Textes venus du configurateur (catégories, note de taille), traduits mot pour mot
  terms: {},
};

// Les autres langues reprennent la structure de FR (i18n-langs.js) ; toute clé absente retombe sur le français.
const LANGS = { fr: FR, ...OTHER };

/** Langue de la page : code TrueLang (nl, en-us, es, it…) → clé du dictionnaire. */
export function detectLang(hint) {
  const raw = String(hint || document.documentElement.lang || '').toLowerCase();
  const short = raw.split(/[-_]/)[0];
  return LANGS[raw] ? raw : LANGS[short] ? short : 'fr';
}

/** Outils de traduction pour une langue : t(clé, variables), n(clé de pluriel, nombre), term(texte FR), money(centimes). */
export function makeI18n(lang) {
  const L = LANGS[lang] || FR;
  const pick = key => (L.ui && L.ui[key] !== undefined ? L.ui[key] : FR.ui[key]);
  const fill = (s, vars) => String(s).replace(/\{(\w+)\}/g, (m, k) => (vars && vars[k] !== undefined ? vars[k] : m));
  const plural = new Intl.PluralRules(L.locale || FR.locale);
  const money = new Intl.NumberFormat(L.locale || FR.locale, { style: 'currency', currency: 'EUR' });
  // Montant rond affiché sans « ,00 » (prix rond du lot : « 151 € »), les autres gardent leurs centimes
  const money0 = new Intl.NumberFormat(L.locale || FR.locale, { style: 'currency', currency: 'EUR', minimumFractionDigits: 0, maximumFractionDigits: 0 });
  return {
    lang,
    ord: L.ord || FR.ord,
    ordH: L.ordH || FR.ordH,
    t: (key, vars) => fill(pick(key) ?? key, vars),
    n: (key, n, vars) => {
      const forms = pick(key) || {};
      return fill(forms[plural.select(n)] ?? forms.other ?? '', { n, ...vars });
    },
    term: s => (L.terms && L.terms[s]) || s,
    hasTerm: s => !!(L.terms && L.terms[s]),
    money: cents => (Math.round(cents) % 100 === 0 ? money0 : money).format(cents / 100),
  };
}
